module.exports = __webpack_public_path__ + "5cccf36a9c6a257ee1b2a77f202b4bd3.png";